import { SettingsFormModel } from 'src/Libs/emergency-power'
import { EmergencyPowerSettingsModel } from 'src/Libs/emergency-power'

const modelToSettingsFormTransformer = (model?: EmergencyPowerSettingsModel): SettingsFormModel => ({
  partialGrid: model?.partialGrid || false,
  wallboxAllow: model?.wallbox?.allow || false,
  delay: model?.delay || 0,
  reserve: model?.reserve.reserveW || 0,
  wallboxMinEpPower: model?.wallbox?.minEpPower || 0,
  wallboxMaxEpPower: model?.wallbox?.maxEpPower || 0,
  wallboxEnergy: model?.wallbox?.energy || 0,
})
export default modelToSettingsFormTransformer
